<template>
    <div class="main-content">
        <b-card no-body class="shadow-none bg-transparent">
            <date-picker></date-picker>
        </b-card>
        <card-loader v-if="loading" height="150px" class="mt-3"/>
        <score-participation-evolution-chart
            v-else-if="score.length"
            :dates="dates"
            :score="score"
            :milestones="milestonesGraph"
            title="Milestones"
            class="mt-3"
        />
        <list
            :columns="columns"
            :rows="milestones"
            :select-options="{
                enabled: false,
            }"
            :pagination-options="{
                perPage: 20,
            }"
            :loading="loading"
            class="mt-3"
        />
    </div>
</template>

<script>
import api from '@/api/api'
import auth from '@/firebase/auth'

export default {
    name: 'Milestones',
    components: {
        CardLoader: () => import('@/components/Loaders/CardLoader'),
        DatePicker: () => import('@/components/datePicker'),
        List: () => import('@/components/List/List'),
        ScoreParticipationEvolutionChart: () => import('@/components/Charts/ScoreParticipationEvolutionChart'),
    },
    data () {
        return {
            dates: [],
            loading: false,
            milestones: [],
            milestonesGraph: [],
            score: [],
            records: [],
            columns: [
                {
                    label: 'Milestone',
                    field: 'increment',
                    type: 'number',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Data',
                    field: 'startDate',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Título',
                    field: 'title',
                    type: 'text',
                },
            ],
        }
    },
    methods: {
        loadData () {
            this.loading = true
            auth
                .currentUser
                .getIdToken()
                .then(async (token) => {
                    await api
                        .get('/reports/milestones', {
                            params: {
                                range: this.range,
                            },
                            headers: {
                                token,
                            },
                        })
                        .then(response => {
                            if (!response.data || !response.data.score.length) return

                            response.data.score = response.data.score.filter(record => record.allResponses.length)
                            this.score = response.data.score.map(record => record.average)
                            this.dates = response.data.score.map(record => record.dateChart)
                            this.milestones = response.data.milestones
                        })
                })
                .then(() => {
                    this.milestones.forEach(milestone => {
                        this.milestonesGraph.push({
                            x: new Date(milestone.startDate).getTime(),
                            strokeDashArray: 2,
                            opacity: 0.5,
                            label: {
                                // borderColor: '#e65862',
                                borderColor: '#663399',
                                borderWidth: 2,
                                borderRadius: 3,
                                textAnchor: 'middle',
                                position: 'bottom',
                                orientation: 'horizontal',
                                style: {
                                    // color: '#e65862',
                                    color: '#663399',
                                    background: '#fff',
                                    fontSize: '20px',
                                },
                                text: String(milestone.increment),
                            },
                        })
                    })
                    this.loading = false
                })
                .catch(err => console.log(err))
        },
    },
    computed: {
        range () {
            return this.$store.getters['dashboard/range']
        },
    },
    watch: {
        range: {
            immediate: true,
            handler () {
                this.loadData()
            },
        },
    },
}
</script>
